import { Component, OnInit } from '@angular/core';
import {AutoService} from '../../services/auto.service';
import {Auto} from './model/auto';
import {Observable} from 'rxjs/Rx';
import {HostListener} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';

@HostListener('window:keydown', ['$event'])
@Component({
        host: {
                '(document:keydown)': 'keyDown($event)',
        },
	selector: 'app-admin-auto',
	templateUrl: './admin-auto.component.html',
	styleUrls: ['./admin-auto.component.css'],
})

export class AdminAutoComponent implements OnInit {
	autos: Auto[];
	public selectedAuto;
	searchText = "";
	selectedIndex = 0;
	show = true;

	constructor(private autoService: AutoService, private activatedRoute: ActivatedRoute, private router: Router) 
{
}
	ngOnInit() { 
		this.activatedRoute.queryParams.subscribe(params => {
			this.searchText = params['s'] || "";
			if(this.searchText != "") {
				this.auto();
			}	
		});
	}

	auto() {
		if (this.searchText != "") {
		 this.autoService.auto(this.searchText)
				   .subscribe(
				       autos => {
							this.autos = autos; //Bind to view
					},
					err => {
					    console.log(err);
					});
					} else {
						 this.autos = new Array();
					}	
	}

	complete() {
		if (this.searchText != "") {
			this.show=false;
		 	this.autoService.complete(this.searchText)
				   .subscribe(
				       autos => {
							this.autos = autos; //Bind to view
					},
					err => {
					    console.log(err);
					});
					} else {
						 this.autos = new Array();
					}	
	}

	 public selectAuto( auto: any, i: number) {
                this.selectedIndex = i;
                this.selectedAuto =  auto;
		this.searchText = this.selectedAuto.Name;
        }

	 keyDown(event: any) {
                switch (event.keyCode) {
                        case 38:
                                this.onUp();
                                event.preventDefault();
                                break;
                        case 40:
                                this.onDown()
                                event.preventDefault();
                                break;
                        case 13:
                                this.complete()
                                event.preventDefault();
                                break;
                }
                return;
	}

	public onDown() {
                if(this.selectedIndex < this.autos.length - 1)
                {
                        this.selectedAuto = this.autos[++this.selectedIndex];
			this.searchText = this.selectedAuto.Name;
                }
        }

        public onUp() {
                if(this.selectedIndex > 0)
                {
                        this.selectedAuto = this.autos[--this.selectedIndex];
			this.searchText = this.selectedAuto.Name;
                }
        }


}



// WEBPACK FOOTER //
// ./src/app/admin/adminAuto/admin-auto.component.ts